import { render, staticRenderFns } from "./KusDocumentSnack.vue?vue&type=template&id=3cb6b9aa"
import script from "./KusDocumentSnack.vue?vue&type=script&lang=js"
export * from "./KusDocumentSnack.vue?vue&type=script&lang=js"
import style0 from "./KusDocumentSnack.vue?vue&type=style&index=0&id=3cb6b9aa&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports